<div *ngIf="doctalkSeriesDetail" class="mt-2 position-relative mb-2 bg-grey cursor-pointer" (click)="navigatetoDetail()">
  <img [src]="doctalkSeriesDetail.banner" class="w-100 post-pic-doc-series position-absolute h-100 text-white"
    onerror="this.src='assets/img/image_placeholder.svg'" alt="banner image">
  <div class="fnt-size14px p-3 position-relative doctlk-dtls-top text-white">
    <h5 class="mb-2">{{doctalkSeriesDetail.title}}</h5>
    <div class="mb-2">
      <span class="mr-4 position-relative">{{doctalkSeriesDetail.views_string}}</span>
      <span class="doc-talk-like mr-4 position-relative"> {{doctalkSeriesDetail.like}} Like(s)</span>
    </div>
    <P class="mb-2">{{doctalkSeriesDetail.description | slice :0: 230}}
      <span style="color:#fff" *ngIf="doctalkSeriesDetail.description.length>230">...</span>
    </P>
    <span *ngFor="let speciality of doctalkSeriesDetail.speciality"> #{{speciality.speciality_name}}</span>

    <p class="mt-2 mb-2">{{mls.languageText.doctalk.key5}}</p>
    <span *ngFor="let speaker of doctalkSeriesDetail.speaker | slice:0:2" class="mr-3">
      <img class="post-pic user-40 rounded-circle" [src]="speaker.profile_pic"
        onerror="this.src='assets/img/image_placeholder.svg'" alt="user image">
      <span class="ml-2">{{speaker.name}}</span>
    </span>

    <span class="text-success cursor-pointer fnt-weight500">+{{doctalkSeriesDetail.speaker.length-2}}</span>

    <div class="play-vide-doctlk">
      <button class="btn btn-success w-100 pt-2 pb-2 mt-3 mb-3">
        <span class="ng-star-inserted">{{mls.languageText.doctalk.key6}}
        </span>
      </button>
      <div class="row text-center">
        <div class="col-4">
          <button class="btn text-truncate fnt-size14px border fnt-weight500 w-100 pt-2 pb-2 pl-1 pr-1 text-white">
            <svg style="margin-top:-4px" viewBox="0 0 16 16" width="18px" class="ng-star-inserted">
              <defs>
                <style class="ng-star-inserted">
                  .dtls-lyk-card {
                    fill: #fff;
                  }
                </style>
              </defs>
              <g data-name="Layer 3" id="Layer_3">
                <path class="dtls-lyk-card"
                  d="M4.53,13.74h.79l.66.7a2.39,2.39,0,0,0,1.73.76l4.34.07a2.1,2.1,0,0,0,2-1.6,1.55,1.55,0,0,0-.12-1s1.57-1.57.52-2.88a1.35,1.35,0,0,0,1-1.37,2.27,2.27,0,0,0-2.28-2.3H10V3.69A3,3,0,0,0,8.15.87L8,.8a.78.78,0,0,0-1.08.72V3.6a1.54,1.54,0,0,1-.2.76l-1,1.73a.52.52,0,0,1-.46.27H4.53">
                </path>
                <path class="dtls-lyk-card"
                  d="M2.71,14.63h0A2.19,2.19,0,0,1,.5,12.44v-5a2.2,2.2,0,0,1,4.4,0v5A2.19,2.19,0,0,1,2.71,14.63Zm0-8.69A1.47,1.47,0,0,0,1.23,7.4v5a1.45,1.45,0,0,0,1.45,1.45h0a1.46,1.46,0,0,0,1.46-1.45v-5A1.47,1.47,0,0,0,2.71,5.94Z">
                </path>
              </g>
            </svg>
            <span class="ng-star-inserted">{{mls.languageText.doctalk.key7}}
            </span>
          </button>
        </div>
        <div class="col-4 p-0"><span
            class="btn text-truncate cursor-pointer fnt-size14px border fnt-weight500 w-100 pt-2 pb-2 pl-1 pr-1 text-white">
            <svg data-name="Layer  bookmarked" id="Layer_ bookmarked" viewBox="0 0 15 15" width="20px"
              class="ng-star-inserted">
              <defs>
                <style class="ng-star-inserted">
                  .dtls-bookmark-card {
                    fill: #fff;
                  }
                </style>
              </defs>
              <path class="dtls-bookmark-card"
                d="M11.54,12.84l-4-3.06-4,3.06v-10a.65.65,0,0,1,.65-.65h6.78a.65.65,0,0,1,.65.65Z"></path>
            </svg>
            <span class="ng-star-inserted">{{mls.languageText.doctalk.key8}}
            </span>
          </span>
        </div>
        <div class="col-4"><button
            class="btn text-truncate fnt-size14px border fnt-weight500 w-100 pt-2 pb-2 pl-1 pr-1 text-white"><svg
              viewBox="0 0 16 16" width="20px">
              <defs>
                <style class="ng-star-inserted">
                  .dtls-shre-card {
                    fill: #fff;
                  }
                </style>
              </defs>
              <g data-name="Layer 3" id="Layer_3">
                <path class="dtls-shre-card" d="M9.5,13.2V9.92C5.33,9.92,2.58,11.2.5,14c.84-4,3.16-8,9-8.8V2l6,5.59Z">
                </path>
              </g>
            </svg> {{mls.languageText.doctalk.key9}}
          </button></div>
      </div>
    </div>
  </div>
</div>

<h3 *ngIf="errorMsg" class="text-center pt-5">{{errorMsg}}</h3>